module.exports = __webpack_public_path__ + "static/media/lamp_module.54781f60.jpg";